import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import {
    checkIsCommunityProductKey,
    checkIsEnterpriseProductKey,
    checkIsInternalProductKey,
} from '@gitbook/app-pricing';
import { Alert } from '@gitbook/spine-react';

/**
 * A CTA to encourage users to enquire about Enterprise if they're dealing with
 * a big migration.
 */
export function EnterpriseMigrationCTA(props: {
    className?: string;
    organization: api.Organization;
    onClose?: () => void;
}): React.ReactNode {
    const { className, organization, onClose } = props;

    if (
        checkIsEnterpriseProductKey(organization.plan) ||
        checkIsCommunityProductKey(organization.plan) ||
        checkIsInternalProductKey(organization.plan)
    ) {
        return null;
    }

    return (
        <Alert
            className={className}
            size="small"
            kind="info"
            title="Need help migrating your docs?"
            details="Our white-glove migration service ensures your content moves smoothly into GitBook."
            action={{
                label: 'Talk to our team',
                kind: 'secondary',
                href: 'https://www.gitbook.com/enterprise',
                target: '_blank',
                onPress: () => {
                    analytics.logEvent(
                        analytics.createOrgEvent(organization, {
                            type: 'organization_open_enterprise_cta',
                        })
                    );
                },
            }}
            onClose={onClose}
        />
    );
}
